import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useStore } from "@/lib/store";
import { api, errorMessage } from "@/lib/api";

export default function PayPalReturn() {
  const { t } = useLang();
  const { clear } = useStore();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState({ phase: "checking" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    if (!token) return setState({ phase: "failed", msg: t("success.failed") });
    api
      .post("/payments/paypal/capture", { token })
      .then(({ data }) => {
        clear();
        setState({ phase: "paid", order: data.order_number });
      })
      .catch((e) => setState({ phase: "failed", msg: e?.response?.status === 404 ? t("success.failed") : errorMessage(e, t) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-24 text-center" data-testid="paypal-return-page">
      {state.phase === "checking" && (<><Loader2 className="h-12 w-12 animate-spin text-gold" /><p className="mt-6 text-lg font-bold" data-testid="payment-checking">{t("success.checking")}</p></>)}
      {state.phase === "paid" && (
        <>
          <CheckCircle2 className="h-14 w-14 text-emerald-400" />
          <h1 className="mt-6 font-display text-3xl sm:text-4xl">{t("success.title")}</h1>
          <div className="panel mt-8 w-full p-6">
            <p className="text-xs font-extrabold uppercase tracking-[0.2em] text-slate-400">{t("success.order_no")}</p>
            <p className="mt-2 font-mono-num text-3xl font-bold text-gold" data-testid="order-number">{state.order}</p>
          </div>
          <p className="mt-5 text-slate-400">{t("success.keep")}</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link to="/track" className="btn-gold" data-testid="success-track-btn">{t("success.track")}</Link>
            <Link to="/" className="btn-ghost" data-testid="success-home-btn">{t("success.home")}</Link>
          </div>
        </>
      )}
      {state.phase === "failed" && (
        <>
          <AlertTriangle className="h-12 w-12 text-amber-400" />
          <p className="mt-6 text-lg font-bold" data-testid="payment-status-msg">{state.msg}</p>
          <Link to="/cart" className="btn-ghost mt-8" data-testid="paypal-retry-btn">{t("cancel.back")}</Link>
        </>
      )}
    </div>
  );
}
